<template>
  <div v-loading="loading" class="preview-container">
    <div v-if="previewType === 'pdf' " class="previewPDF-container">
      <div class="pdf-scroll">
        <iframe ref="iframeDomNode" :src="pdfurl" frameborder="0" style="width: 100%; height: 100%" />
      </div>
      <!-- pdf缩进按钮 -->
      <!-- 放大缩小 -->
      <div class="pdf-progress">
        <div class="progress-btn">
          <!-- <div @click.stop="prePage" class="per"> -->
          <div :class="{select:idx==1} " @touchstart="idx=1" @touchend="idx=-1" @click="scaleX">
            -
          </div>
          <el-progress :percentage="percentage" :show-text="false" />
          <!-- <div @click.stop="nextPage" class="next"> -->
          <div :class="{select:idx==0}" @touchstart="idx=0" @touchend="idx=-1" @click="scaleD">
            +
          </div>
        </div>
      </div>
    </div>
    <div v-if="isPic(previewType)" class="previewImg-container">
      <el-image
        :key="previewUrl"
        :src="previewUrl"
        @load="handleLoadImage()"
        @error="handImageError()"
        fit="contain"
      />
    </div>
    <div v-if="previewType === 'txt'" class="previewTXT-container">
      {{ evidenceContent }}
    </div>
    <div v-if="previewType === 'html'" class="previewHtml-container">
      <iframe :src="previewUrl" frameborder="0" scrolling="auto" />
    </div>
    <div v-if="previewType === 'mp4' || previewType === 'avi'" class="previewTXT-container">
      <video :src="previewUrl"></video>
    </div>
  </div>
</template>

<script>

export default {
  props: {
    evidencePath: {
      type: String,
      required: true
    },
    evidenceType: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      loading: false,
      currentPage: 0, // pdf文件页码
      pageCount: 0, // pdf文件总页数
      percentage: 0, // 进度条
      pdfurl: '',
      publicPath: '',
      // pdfUrl: 'http://172.31.47.8:88/group1/M00/00/2C/rB8vCF8sC8aAEVGSAACKiYWtPv4699.pdf', // pdf地址
      pdfParams: {}, // pdf参数
      numPages: 1, // pdf页码
      scale: 100, // 放大系数
      iframeWin: null,
      idx: -1,
      pageTotalNum: 1, // pdf总页数
      previewUrl: '', // 预览文件地址
      previewType: '', // 预览文件类型
      evidenceContent: '' // 预览TXT文件内容
    }
  },
  watch: {
    // 文件地址
    evidencePath (newVal) {
      this.previewUrl = newVal
    },
    // 预览文件类型
    evidenceType (newVal) {
      this.previewType = newVal
      console.log('previewType', this.previewType)
      if (this.isPic(newVal)) {
        this.loading = true
      }
      if (newVal === 'txt') {
        this.urlToBlob()
      }
      if (newVal === 'pdf') {
        this.loadFile()
      }
    }
  },
  created () {
    this.previewUrl = this.evidencePath
    this.previewType = this.evidenceType
    this.loadFile()
  },
  mounted () {
    //   放大进度
    this.publicPath = process.env.NODE_ENV === 'production' ? './' : '/'
    this.percentage = ((this.scale - 100) / 150) * 100
  },
  methods: {
    // pdf加载时
    loadPdfHandler (e) {
      this.currentPage = 1 // 加载的时候先加载第一页
    },
    isPic (type) {
      return type === 'png' || type === 'jpg' || type === 'jpeg' || type === 'gif' || type === 'bmp'
    },
    handleLoadImage () {
      this.loading = false
    },
    handImageError () {
      this.loading = false
    },
    loadFile () {
      if (this.previewType === 'pdf') {
        // 获取所有PDF页面
        try {
          this.$nextTick(() => {
            this.pdfurl = this.publicPath + 'hybrid/pdf.html' + `?file=${this.previewUrl}`
            console.log('获取所有PDF页面', this.pdfurl)
          })
        } catch (error) {
          console.log('获取所有PDF页面ERROR', error)
        }
      }

      if (this.previewType === 'txt') {
        this.urlToBlob()
      }
    },
    // PDF加载
    pageLoaded (e) {
      this.percentage = (this.numPages / this.pageTotalNum) * 100
    },
    // 缩小PDF
    scaleX () {
      if (this.scale === 100) {
        this.percentage = 0
        return
      }
      this.scale += -5
      // this.$refs.pdf_ref.forEach(item => {
      //   item.$el.style.width = parseInt(this.scale) + '%'
      // })
      this.percentage = ((this.scale - 100) / 150) * 100
      this.$nextTick(() => {
        this.$refs.iframeDomNode.contentWindow.reduceScale(this.percentage)
      })
      console.log(this.percentage)
    },
    // 放大PDF
    scaleD () {
      if (this.scale === 250) {
        this.percentage = 100
        return
      }
      this.scale += 5
      // this.$refs.pdf_ref.forEach(item => {
      //   item.$el.style.width = parseInt(this.scale) + '%'
      // })
      this.percentage = ((this.scale - 100) / 150) * 100
      this.$nextTick(() => {
        this.$refs.iframeDomNode.contentWindow.addScale(this.percentage)
      })
    },
    // 预览txt
    urlToBlob () {
      // 可以是具体.txt也可以是接口返回的blob，或者web转换
      const xhr = new XMLHttpRequest()
      xhr.open('get', this.evidencePath, true)
      // xhr.responseType = 'blob'
      const self = this// onload this指向为window中转一下
      xhr.onload = function () {
        if (this.status === 200) {
          // console.log(this.response)
          self.evidenceContent = this.response
          const reader = new FileReader()
          reader.onload = function () {
            self.txtPre = reader.result// 获取的数据data
            console.log('reader.result', reader.result)
          }
          // reader.readAsText(this.response)
        }
      }
      xhr.send()
    }
  }
}
</script>

<style lang='scss' scope>
    .pdf-btn {
        display: flex;
        position: absolute;
        right: 10px;
        top: 10px;
        z-index: 999;
    }

    .pdf-scroll {
        height: 100%;
        // overflow: auto
    }

    .pdf-progress {
        height: 23px;
        width: 100%;
        background: #edeff6;
        // position: relative;
        // position: absolute;
        bottom: 10px;
        z-index: 999;
        text-align: center;

        .progress-btn {
            // position: absolute;
            width: 150px;
            display: inline-flex;
            justify-content: space-between;
            align-items: center;
            // right: 22px;
            color: #354761;

            .el-progress {
                width: 100%;
                padding: 0 10px;

                .el-progress-bar__outer {
                    background-color: #fff;
                }
            }

            .progress-bar {
                display: flex;
                align-items: center;

                .progress-point {
                    width: 107px;
                    height: 7px;
                    background-color: #fff;
                    border-radius: 4px;

                    .progress-o {
                        width: 9px;
                        height: 9px;
                        background: #d7e7ff;
                        border-radius: 5px;
                        border: 1px solid #5395fd;
                    }
                }
            }

            div {
                cursor: pointer;
                user-select: none;
            }

            .next {
                cursor: pointer;
                user-select: none;
            }

            .per {
                user-select: none;
                cursor: pointer;
            }
        }
    }

    .preview-container {
        width: 100%;
        height: 100%;

        .previewPDF-container {
            height: 100%;
        }

        .previewTXT-container {
            padding: 10px;
            font-size: 14px;
            font-family: PingFangSC-Medium, PingFang SC, sans-serif;
            font-weight: 500;
            color: #354761;
            line-height: 20px;
        }

        .previewHtml-container {
            height: 100%;

            iframe {
                width: 100%;
                height: 100%;

                #document {
                    /*定义滚动条高宽及背景 高宽分别对应横竖滚动条的尺寸*/
                    ::-webkit-scrollbar {
                        width: 8px;
                        height: 8px;
                        background-color: transparent;
                        position: absolute;
                        right: 0;
                        bottom: 0;
                    }

                    /*定义滚动条轨道 内阴影+圆角*/
                    ::-webkit-scrollbar-track {
                        // -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, 0.3);
                        border-radius: 10px;
                        background-color: transparent;
                    }

                    /*定义滑块 内阴影+圆角*/
                    ::-webkit-scrollbar-thumb {
                        border-radius: 10px;
                        // -webkit-box-shadow: inset 0 0 6px rgba(0, 0, 0, .3);
                        background-color: #dee4ff;
                    }
                }
            }
        }
    }
</style>
